export default "__VITE_ASSET__8013d922__"